import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  Card,
  Row,
  Col,
  Select,
  DatePicker,
  Input,
  Button,
  Collapse,
  Table,
  Tag,
  Spin,
  Pagination,
  Icon,
  notification,
} from 'antd'
import moment from 'moment'
import _ from 'lodash'
import Request, {
  productionStatusList,
  getProductionStatusColor,
} from '../../../request'
import BoardModal2 from './boardModal2'
import styles from './styles.less'

const { Option } = Select
const { RangePicker } = DatePicker
const { Panel } = Collapse

const fmt = (d) => (d ? moment(d).format('ll') : '-')
const plural = (n, word) => `${n} ${word}${Number(n) === 1 ? '' : 's'}`

const labelOf = (obj) => {
  if (obj == null) return ''
  if (typeof obj === 'string') return obj
  return obj.name || obj.categoryName || obj.title || obj.label || ''
}

const SUBCATEGORY_LABELS = {
  general: 'General',
  production_as_on: 'Production As On',
  completion: 'Completion',
}

// known subcategories first, then any other (e.g. Kanban lane) alphabetically
const SUBCATEGORY_ORDER = ['general', 'production_as_on', 'completion']

const subCategoryLabel = (key) => SUBCATEGORY_LABELS[key] || key

const sortSubCategories = (keys) =>
  [...keys].sort((a, b) => {
    const ai = SUBCATEGORY_ORDER.indexOf(a)
    const bi = SUBCATEGORY_ORDER.indexOf(b)
    if (ai === -1 && bi === -1) return String(a).localeCompare(String(b))
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })

// Production Order List 2 — the primary grouping key here is Order ID
// (the existing list.js groups by capture date). Order IDs originate from the
// Order Dispatch ("Order List") module; this page groups all production media
// by the order it belongs to.
class ProductionOrderList2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      orders: [],
      total: 0,
      page: 1,
      pageSize: 10,
      activeKeys: [],
      // filters
      dateRange: null,
      category: undefined,
      subCategory: undefined,
      user: undefined,
      orderId: '',
      status: undefined,
      product: undefined,
      // option sources
      categoriesRaw: [],
      users: [],
      productOptions: [],
      // production order form details keyed by productionOrderId
      formByOrderId: {},
      // board (order-driven)
      boardVisible: false,
      activeGroup: null,
    }
  }

  componentDidMount() {
    this.fetchOptionData()
    this.fetchList()
  }

  fetchOptionData = () => {
    Request.getAllCategories().then(({ error, data }) => {
      if (!error && data) this.setState({ categoriesRaw: data })
    })
    Request.getAllROList({ results: 1000 }).then(({ error, data }) => {
      if (!error && data) this.setState({ users: data })
    })
    // all products from the stock master (same source as the form's Product field)
    Request.getStockProductMaster({ results: 2000 }).then((res) => {
      const list = !res ? [] : Array.isArray(res) ? res : res.data || res.products || []
      this.setState({ productOptions: _.uniq(list.map((p) => p.name).filter(Boolean)) })
    })
    // production order form details (shown in each order's group header)
    Request.productionOrderFormList({ results: 5000 }).then(({ error, data }) => {
      if (!error && data) {
        const map = {}
        data.forEach((d) => {
          map[String(d.productionOrderId)] = d
        })
        this.setState({ formByOrderId: map })
      }
    })
  }

  buildParams = () => {
    const {
      page,
      pageSize,
      dateRange,
      category,
      subCategory,
      user,
      orderId,
      status,
      product,
    } = this.state

    const params = { page: page, count: pageSize, results: pageSize }
    if (dateRange && dateRange.length === 2) {
      params.startDate = dateRange[0].startOf('day').toISOString()
      params.endDate = dateRange[1].endOf('day').toISOString()
    }
    if (category) params.category = category
    if (subCategory) params.subCategory = subCategory
    if (user) params.user = user
    if (orderId) params.orderId = orderId
    if (status) params.status = status
    if (product) params.product = product
    return params
  }

  fetchList = () => {
    this.setState({ loading: true })
    Request.productionOrderList(this.buildParams()).then((res) => {
      const { error, data, total } = res || {}
      if (!error) {
        const orders = data || []
        this.setState({
          loading: false,
          orders: orders,
          total: total || orders.length,
          activeKeys: this.computeGroupKeys(orders),
        })
      } else {
        this.setState({ loading: false, orders: [], total: 0 })
        notification.error({ message: 'Failed to load production orders' })
      }
    })
  }

  // Primary grouping key: Order ID
  computeGroups = (orders) => {
    const map = {}
    orders.forEach((o) => {
      const key = o.orderId ? String(o.orderId) : 'unassigned'
      if (!map[key]) map[key] = []
      map[key].push(o)
    })
    const keys = Object.keys(map).sort((a, b) => {
      if (a === 'unassigned') return 1
      if (b === 'unassigned') return -1
      return String(b).localeCompare(String(a), undefined, { numeric: true })
    })
    return keys.map((k) => ({
      key: k,
      label: k === 'unassigned' ? 'Unassigned' : `#${k}`,
      orderId: k === 'unassigned' ? '' : k,
      orders: map[k],
      photosCount: map[k].reduce((s, o) => s + (Number(o.photosCount) || 0), 0),
      videosCount: map[k].reduce((s, o) => s + (Number(o.videosCount) || 0), 0),
      mediaCount: map[k].reduce(
        (s, o) => s + (Number(o.photosCount) || 0) + (Number(o.videosCount) || 0),
        0
      ),
    }))
  }

  computeGroupKeys = (orders) => this.computeGroups(orders).map((g) => g.key)

  handleSearch = () => {
    this.setState({ page: 1 }, this.fetchList)
  }

  approveAll = (orderId, e) => {
    if (e) e.stopPropagation()
    if (!orderId) return
    Request.approveAllProductionOrder({ orderId }).then((res) => {
      if (res && !res.error) {
        notification.success({ message: 'Order marked as All Approved' })
        this.fetchList()
      } else {
        notification.error({ message: (res && res.message) || 'Failed to update order' })
      }
    })
  }

  handleReset = () => {
    this.setState(
      {
        dateRange: null,
        category: undefined,
        subCategory: undefined,
        user: undefined,
        orderId: '',
        status: undefined,
        product: undefined,
        page: 1,
      },
      this.fetchList
    )
  }

  onPageChange = (page, pageSize) => {
    this.setState({ page: page, pageSize: pageSize }, this.fetchList)
  }

  // Order-driven: open the combined board (review + board) for one order
  openBoard = (group) => {
    const first = (group.orders && group.orders[0]) || {}
    this.setState({
      activeGroup: {
        key: group.key,
        label: group.label,
        orderId: group.orderId,
        mediaCount: group.mediaCount,
        orderCount: group.orders ? group.orders.length : 0,
        userName: first.userName,
        category: first.category,
        subCategory: first.subCategory,
      },
      boardVisible: true,
    })
  }

  closeBoard = () => {
    this.setState({ boardVisible: false })
  }

  getSubCategoryOptions = () => {
    const { categoriesRaw, category } = this.state
    let subs = []
    categoriesRaw.forEach((c) => {
      if (category && labelOf(c) !== category) return
      const list = c.subCategories || c.subcategories || c.subCategory || []
      if (Array.isArray(list)) subs = subs.concat(list.map(labelOf))
    })
    if (!subs.length) subs = this.state.orders.map((o) => o.subCategory)
    return _.uniq(subs.filter(Boolean))
  }

  getCategoryOptions = () => {
    const { categoriesRaw, orders } = this.state
    let cats = categoriesRaw.map(labelOf)
    if (!cats.length) cats = orders.map((o) => o.category)
    return _.uniq(cats.filter(Boolean))
  }

  getUserOptions = () => {
    const { users, orders } = this.state
    let list = users.map((u) => u.name).filter(Boolean)
    if (!list.length) list = orders.map((o) => o.userName)
    return _.uniq(list.filter(Boolean))
  }

  renderFilters = () => {
    const { dateRange, category, subCategory, user, orderId, status, product, productOptions } = this.state
    return (
      <Card className={styles.filterBar} bodyStyle={{ paddingBottom: 0 }}>
        <Row gutter={12}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <RangePicker
              style={{ width: '100%', marginBottom: 12 }}
              value={dateRange}
              onChange={(val) => this.setState({ dateRange: val })}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Category"
              value={category}
              onChange={(val) =>
                this.setState({ category: val, subCategory: undefined })
              }
            >
              {this.getCategoryOptions().map((c) => (
                <Option key={c} value={c}>
                  {c}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Subcategory"
              value={subCategory}
              onChange={(val) => this.setState({ subCategory: val })}
            >
              {this.getSubCategoryOptions().map((c) => (
                <Option key={c} value={c}>
                  {c}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Select
              allowClear
              showSearch
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="User"
              value={user}
              onChange={(val) => this.setState({ user: val })}
            >
              {this.getUserOptions().map((u) => (
                <Option key={u} value={u}>
                  {u}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Product"
              value={product}
              onChange={(val) => this.setState({ product: val })}
            >
              {productOptions.map((p) => (
                <Option key={p} value={p}>
                  {p}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4}>
            <Input
              style={{ marginBottom: 12 }}
              placeholder="Order ID"
              value={orderId}
              allowClear
              onChange={(e) => this.setState({ orderId: e.target.value })}
              onPressEnter={this.handleSearch}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              allowClear
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Status"
              value={status}
              onChange={(val) => this.setState({ status: val })}
            >
              {productionStatusList.map((s) => (
                <Option key={s} value={s}>
                  {s}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={16} lg={12}>
            <Button
              type="primary"
              icon="search"
              onClick={this.handleSearch}
              style={{ marginRight: 8, marginBottom: 12 }}
            >
              Search
            </Button>
            <Button icon="reload" onClick={this.handleReset} style={{ marginRight: 8, marginBottom: 12 }}>
              Reset
            </Button>
            <Button
              icon="sync"
              loading={this.state.loading}
              onClick={this.fetchList}
              style={{ marginBottom: 12 }}
            >
              Refresh
            </Button>
          </Col>
        </Row>
      </Card>
    )
  }

  getColumns = () => [
    { title: 'User Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Category', dataIndex: 'category', key: 'category' },
    {
      title: 'Subcategory',
      key: 'subCategory',
      render: (val, r) => {
        const counts = r.subCategoryCounts || {}
        const keys = sortSubCategories(Object.keys(counts))
        // older API responses have no per-subcategory counts — show the
        // single (first) subcategory as before
        if (!keys.length) return subCategoryLabel(r.subCategory) || '-'
        return keys.map((k) => {
          const c = counts[k] || {}
          return (
            <div key={k} className={styles.subCatLine}>
              <span className={styles.subCatLabel}>{subCategoryLabel(k)}:</span>
              <Tag color="green">{Number(c.completed) || 0}</Tag>
              <Tag color="red">{Number(c.rejected) || 0}</Tag>
            </div>
          )
        })
      },
    },
    {
      title: 'Photos',
      key: 'photosCount',
      width: 90,
      render: (val, r) => (
        <Tag>
          <Icon type="picture" /> {Number(r.photosCount) || 0}
        </Tag>
      ),
    },
    {
      title: 'Videos',
      key: 'videosCount',
      width: 90,
      render: (val, r) => (
        <Tag>
          <Icon type="video-camera" /> {Number(r.videosCount) || 0}
        </Tag>
      ),
    },
    {
      title: 'Upload Date',
      key: 'uploadedDate',
      width: 140,
      render: (val, r) => fmt(r.uploadedDate || r.createdAt),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 170,
      render: (val, r) => {
        // already finalized -> solid green "Approved" status tag (like Pending)
        if (val === 'All Approved') {
          return (
            <Tag className={styles.statusBadge} color="#52c41a">
              Approved
            </Tag>
          )
        }
        // every photo approved but not finalized yet -> clickable action button
        if (r.allApproved) {
          return (
            <Button
              type="primary"
              icon="check"
              style={{
                background: '#52c41a',
                borderColor: '#52c41a',
                fontWeight: 500,
                boxShadow: '0 2px 0 rgba(0,0,0,0.045)',
              }}
              onClick={(e) => this.approveAll(r.orderId, e)}
            >
              All Approved
            </Button>
          )
        }
        return (
          <Tag className={styles.statusBadge} color={getProductionStatusColor(val || 'Pending')}>
            {val || 'Pending'}
          </Tag>
        )
      },
    },
  ]

  render() {
    const {
      loading,
      orders,
      total,
      page,
      pageSize,
      activeKeys,
      boardVisible,
      activeGroup,
    } = this.state
    const groups = this.computeGroups(orders)
    const columns = this.getColumns()

    return (
      <PageHeaderWrapper title={`Production Order List`}>
        {this.renderFilters()}

        <Card bordered>
          <Spin spinning={loading}>
            {groups.length === 0 ? (
              <div className={styles.emptyWrap}>
                <Icon type="inbox" style={{ fontSize: 36, display: 'block', marginBottom: 8 }} />
                No production orders found
              </div>
            ) : (
              <Collapse
                bordered={false}
                className={styles.collapseWrap}
                activeKey={activeKeys}
                onChange={(keys) => this.setState({ activeKeys: keys })}
              >
                {groups.map((g) => {
                  const form = this.state.formByOrderId[String(g.orderId)] || null
                  return (
                  <Panel
                    key={g.key}
                    extra={
                      <span onClick={(e) => e.stopPropagation()}>
                        <Button
                          type="primary"
                          size="small"
                          icon="eye"
                          onClick={() => this.openBoard(g)}
                        >
                          Review
                        </Button>
                      </span>
                    }
                    header={
                      <span className={styles.groupHeader}>
                        <span className={styles.groupDate}>{g.label}</span>
                        <span className={styles.countChip}>
                          <Icon type="picture" /> {plural(g.photosCount, 'Photo')}
                        </span>
                        <span className={styles.countDivider}>|</span>
                        <span className={styles.countChip}>
                          <Icon type="video-camera" /> {plural(g.videosCount, 'Video')}
                        </span>
                        <span className={styles.orderCount}>{plural(g.orders.length, 'Item')}</span>
                        {form && form.product ? (
                          <Tag color="blue" style={{ marginLeft: 8 }}>
                            <Icon type="tag" /> {form.product}
                          </Tag>
                        ) : null}
                        {form && form.quantity != null ? (
                          <Tag>
                            Qty: {form.quantity}{form.unitOfMeasurement ? ` ${form.unitOfMeasurement}` : ''}
                          </Tag>
                        ) : null}
                        {form && form.expectedCompletionDate ? (
                          <Tag>
                            <Icon type="calendar" /> Est: {moment(form.expectedCompletionDate).format('DD-MM-YYYY')}
                          </Tag>
                        ) : null}
                      </span>
                    }
                  >
                    <Table
                      className={styles.clickableTable}
                      size="small"
                      rowKey={(r) => r._id || r.orderId}
                      columns={columns}
                      dataSource={g.orders}
                      pagination={false}
                      onRow={() => ({
                        onClick: () => this.openBoard(g),
                      })}
                    />
                  </Panel>
                  )
                })}
              </Collapse>
            )}

            <div className={styles.paginationBar}>
              <Pagination
                current={page}
                pageSize={pageSize}
                total={total}
                showSizeChanger
                pageSizeOptions={['10', '25', '50', '100']}
                showTotal={(t) => `Total ${t} orders`}
                onChange={this.onPageChange}
                onShowSizeChange={this.onPageChange}
              />
            </div>
          </Spin>
        </Card>

        <BoardModal2
          visible={boardVisible}
          group={activeGroup}
          onClose={this.closeBoard}
          onUpdated={this.fetchList}
        />
      </PageHeaderWrapper>
    )
  }
}

export default ProductionOrderList2
